// extracted by mini-css-extract-plugin
export default {"pojecie":"Pojecie_pojecie__9Hrib","dymek":"Pojecie_dymek__25nfi","definicja":"Pojecie_definicja__4tD5P","wszystkie":"Pojecie_wszystkie__7OWnI"};